export default __webpack_public_path__ + "static/media/Nonstop Assault.11fb5e13.png";